module.exports = __webpack_public_path__ + "img/LoGoIMI.4572404b.png";